// Bridge letting ActionHUD's "View" button act on the crafting page (audit L2):
// a crafting job runs ~seconds and players are usually still on /crafting when
// it completes, where navigate('/crafting') is a same-path no-op. CraftingView
// registers a handler while mounted; on any other page there is no handler and
// the caller falls back to normal navigation.
let handler = null

export function registerOpenStationModal(fn) {
  handler = fn
  return () => {
    if (handler === fn) handler = null
  }
}

export function openStationModal(label) {
  return handler ? handler(label) : false
}
